import { firestore } from './utils/firebase'
import { collection, addDoc, onSnapshot, deleteDoc, doc, where, query, updateDoc} from "firebase/firestore"; 
import { useEffect, useState } from 'react'
import SignIn from './components/SignIn'
import Register from './components/Register';


function App() {
  const [note, setNote] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const [notesFromDb, setNotesFromDb] = useState([])
  const [notesLoading , setNotesLoading] = useState(false)

  
  const [user, setUser] = useState({
    email: '',
    uid: '',
    userName: '',

  })
  
  useEffect(() => {

    const collectionRef = collection(firestore,"to-do-list")
    const queryParams = where('uid', '==', user.uid)
    const notesQuery = query(collectionRef, queryParams)
    // onsnapshot is used so the data will update itself
    onSnapshot(notesQuery, (snapshot) =>{ 

      setNotesLoading(true);
      setNotesFromDb(snapshot.docs.map((doc) => ({...doc.data(), id:doc.id})));
      setNotesLoading(false)
    })
  });
  
  function handleUserRecieved(user){
    console.log(user)
    setUser({
      email: user.email,
      uid: user.uid,
      userName: user.displayName,
    })
    
  }


  function handleLogOut(){
    setUser({
      email: '',
      uid: '',
      userName: '',
    })
    alert('Your logged out')

  }
   
  function UpdateNote(event){
    setNote(event.target.value)
  }

  const onClickHandler = async () =>{
    setButtonLoading(true)
    const collectionRef = collection(firestore, "to-do-list");
    const payload = { note: note, uid:user.uid }
    await addDoc( collectionRef, payload );
    setNote('');
    setButtonLoading(false)
  }

  const handleDelete = async(id) => {
    const docRef = doc(firestore, "to-do-list",id);
    await deleteDoc(docRef)
  }

  const handleEdit = async(id) => {
    const note = prompt('Change Your Note Here!')
    const docRef = doc(firestore,"to-do-list",id)
    const payload = {
      note: note
    }
    console.log(note)
    updateDoc(docRef, payload)
    setNote('');
  }

  
  return (
    <>
      <div className="flex flex-col items-center">
      <header>
        {user.uid &&
        <div className='flex flex-row'>
          <input className='w-full' type="text" onChange={ UpdateNote }  value={ note } id="task_Input"  name='nameOfNote' placeholder="What's Next!"/>
          {buttonLoading ? <p>Loading....</p> : <button className='border-white border-solid  px-2 py-1 text-white bg-gradient-to-r from-gray-600 to-gray-800 rounded' onClick={onClickHandler}  id="submit" name='addNoteButton'>Submit</button>}
        </div>
        }
        {/* condition ? run if true : run if false */}
      
        {!user.uid && 
          <div className='grid grid-cols-1 place-items-center md:mt-10 p-32  bg-gradient-to-t from-gray-600 to-blue-800 rounded'>
            <SignIn handleUserRecieved={handleUserRecieved} />
            <Register handleUserRecieved={handleUserRecieved}/>

          </div>
        }
        
      </header>
      {user.uid &&
      <main>
          <h2 className='underline'>THINGS TO DO:</h2>
          <div className=''>

            { notesLoading ? <p>Loading....</p> : 
            
              <ul className=''>
                {notesFromDb.map((note) => {
                  return(
                    <div className='m-1 p-4 bg-gradient-to-r from-gray-600 to-blue-800 rounded'>
                      <li key={note.id}>{ note.note }

                        <div className='float-right '>
                        <button className='text-green-600 hover:text-green-300   px-2 py-1 mr-2'  onClick={()=> (handleEdit(note.id))}>Edit</button>
                        <button className='text-red-600 hover:text-red-300 ' onClick={()=> (handleDelete(note.id))}>Delete</button>
                        </div>
                      </li> 
                    </div>
                  )
                })}
              </ul>
            }    
          </div>
      </main>
      }
      {user.uid && 

      <button className=' border-solid max-w-xs justify-center py-2 px-4 bg-gradient-to-r from-gray-600 to-gray-800 hover:opacity-80 rounded' onClick={handleLogOut}>Log Out</button>
      }
    </div>
    </>
  );
}

export default App;
